"use client";

import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const XIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M4 4l16 16M20 4l-16 16" />
  </svg>;
export default function Footer() {
  const {
    ref: sitemapRef,
    isVisible: sitemapVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    url: "https://www.facebook.com/DandJent/",
    label: "Facebook"
  }, {
    icon: Instagram,
    url: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: XIcon,
    url: "https://twitter.com",
    label: "X (formerly Twitter)"
  }];
  return <footer className="relative bg-dark-background text-foreground-dark overflow-hidden py-12 px-4">
      {}
      <div className="absolute inset-0 opacity-5">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="memphis-pattern" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse">
              <circle cx="20" cy="20" r="3" fill="currentColor" />
              <rect x="50" y="10" width="15" height="15" fill="currentColor" transform="rotate(45 57.5 17.5)" />
              <path d="M80 30 L90 40 L85 50 Z" fill="currentColor" />
              <line x1="10" y1="60" x2="30" y2="70" stroke="currentColor" strokeWidth="2" />
              <circle cx="70" cy="80" r="5" fill="none" stroke="currentColor" strokeWidth="2" />
              <rect x="95" y="95" width="20" height="8" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#memphis-pattern)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="flex justify-center mb-8">
          <Link to="/HomePage" className="focus-ring rounded-md">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1448648/img/dj_entertainment_full_color_logo.png" alt="D&J Entertainment Logo" className="h-7" />
          </Link>
        </div>

        {}
        <div className="flex justify-center gap-6 mb-10">
          {socialLinks.map((social, i) => {
          const Icon = social.icon;
          return <Link key={social.label} to={social.url} newTab data-index={i} className="group focus-ring rounded-full p-2 hover:bg-primary/10 transition-all duration-[var(--duration-medium)]" aria-label={social.label}>
                <Icon className="size-5 text-accent transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-[15deg]" />
              </Link>;
        })}
        </div>

        {}
        <nav ref={sitemapRef} className={`
            text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]
            ${sitemapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
          `}>
          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm text-muted mb-8">
            <li>
              <Link to="/HomePage" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded-sm px-1">
                Home
              </Link>
            </li>
            <li>
              <span className="text-muted/40">|</span>
            </li>
            <li>
              <Link to="#services" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded-sm px-1">
                Services
              </Link>
            </li>
            <li>
              <span className="text-muted/40">|</span>
            </li>
            <li>
              <Link to="#about" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded-sm px-1">
                About
              </Link>
            </li>
            <li>
              <span className="text-muted/40">|</span>
            </li>
            <li>
              <Link to="#contact" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded-sm px-1">
                Contact
              </Link>
            </li>
          </ul>
        </nav>

        {}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-xs text-muted mb-6">
          <div className="flex items-center gap-2">
            <Phone className="size-3.5 text-accent" />
            <Link to="tel:(123) 456-7890" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded-sm">636-235-1115</Link>
          </div>
          <div className="flex items-center gap-2">
            <Mail className="size-3.5 text-accent" />
            <Link to="mailto:contact@djentertainment.com" className="hover:text-accent transition-colors duration-[var(--duration-fast)] focus-ring rounded-sm">
              contact@djentertainment.com
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="size-3.5 text-accent" />
            <span>Warrenton, MO</span>
          </div>
        </div>

        {}
        <div className="text-center text-xs text-muted/60 border-t border-muted/20 pt-6">
          <p>© {new Date().getFullYear()} D&J Entertainment. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}